import script from "./ExamPaper3.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamPaper3.vue?vue&type=script&setup=true&lang=js"

import "./ExamPaper3.vue?vue&type=style&index=0&id=7b13ce16&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b13ce16"]])

export default __exports__